/**
 * @fileoverview The Agent Console digest table (`GenerativeAiAgentsApiDataTable`)
 * is shared by the Canvas, Data, and QA routes, but each category has its own
 * dedicated Operator scene-root feature flipper - gating must be per-category
 * rather than one flipper standing in for all three. Both the digest scene
 * (to gate `BrazeOperatorProviderWithFeatureFlipper`) and its registered page
 * context (to know whether the Create agent menu's tool is actually
 * registered) need this same mapping, so it lives here rather than in either
 * consumer.
 * @owner @Appboy/intelligence
 */

import type { FeatureName } from "@lib/featureFlipper";

import { AGENT_CATEGORIES } from "./agentCategory";
import type { AgentCategory } from "./agentCategory";

/** The Operator scene-root feature flipper for each Agent Console digest category. */
export const agentConsoleOperatorFeatureByCategory: Record<AgentCategory, FeatureName> = {
  [AGENT_CATEGORIES.CANVAS]: "sage_ai_agentic_scene_root_agent_console_canvas_step_agents",
  [AGENT_CATEGORIES.DATA]: "sage_ai_agentic_scene_root_agent_console_data_agents",
  [AGENT_CATEGORIES.QA]: "sage_ai_agentic_scene_root_agent_console_qa_agents",
};
